/* global ShopgateProductDetailsCore, OffAmazonPayments, jQuery */
import AmazonPay from '../app/amazon-pay/AmazonPayFactory';
import AmazonPayUIFactory from './amazon-pay/AmazonPayUIFactory';
import Logger from './debug/tagged-logger';

((function ($) {
  // For apps
  window.AmazonPay = AmazonPay;

  let paymentButtonRequestRunning = false;

  /**
   * Jquery plugin for amazon payments button (web)
   * @param {Object} opts opts
   * @return {jQuery}
   */
  $.fn.shopgateAmazonPaymentsButton = function (opts) {
    const defaults = {
      amazonPaymentsData: '',
    };

    const options = $.extend(true, {}, defaults, opts);

    if (options.amazonPaymentsData.isApp) {
      return $();
    }

    return this.each(function () {
      const $paymentButton = $(this);
      const buttonId = $paymentButton.prop('id');
      let orderReferenceId;

      /**
       * Submits necessary data to perform the checkout with amazon payment
       * @private
       * @returns {bool}
       */
      function submitAmazonPaymentsData() {
        if (paymentButtonRequestRunning) {
          return false;
        }

        paymentButtonRequestRunning = true;

        const requestData = {};
        let source = $paymentButton.data('source');

        // Legacy check for old payment buttons
        if ($paymentButton.data('productPage')) {
          source = 'product';
        }

        // Get some data about the current selected product
        if (source === 'product' && typeof ShopgateProductDetailsCore !== 'undefined') {
          requestData.selected_values = ShopgateProductDetailsCore.getSelectedValues();
        }

        // Add the session id
        if (orderReferenceId) {
          requestData.mwssession = orderReferenceId;
        }

        // Submit the data
        $.shopgate.ajax({
          url: options.amazonPaymentsData.redirect_url,
          data: requestData,
          success: () => {
          },
          complete: () => {
            paymentButtonRequestRunning = false;
          },
        });

        return true;
      }

      if (options.amazonPaymentsData.session_id && !options.amazonPaymentsData.session_expired) {
        $paymentButton.click(() => {
          orderReferenceId = options.amazonPaymentsData.session_id;
          submitAmazonPaymentsData();
        });
      } else {
        // Apply some javascripts from amazon to the amazon payments button
        if (typeof OffAmazonPayments === 'undefined') {
          $paymentButton.hide();
          console.log('OffAmazonPayments undefined');
          return false;
        }
        new OffAmazonPayments.Widgets.Button({
          sellerId: options.amazonPaymentsData.merchant_id,
          onSignIn: (orderReference) => {
            // The user successfully signed in and we got a session id
            orderReferenceId = orderReference.getAmazonOrderReferenceId();

            // Submit the data to the backend
            submitAmazonPaymentsData();
          },
          onError: () => {
          },
        }).bind(buttonId);

        /* Take care that the click listener is only added once to the payment button.
         * We had situations where the plugin was executed multiple times for the same button which
         * caused multiple identical requests for just one button click.
         * In combination with the _paymentButtonRequestRunning variable
         * this situation shouldn't happen again :-P
         */
        if (!$paymentButton.data('paymentPluginExecuted')) {
          $paymentButton.off('click.amazonPaymentsPaymentButton').on('click.amazonPaymentsPaymentButton', function (e) {
            if (e.target.nodeName === 'DIV') {
              $(this).find('img').trigger('click');
            }
          }).data('paymentPluginExecuted', true);
        }
      }

      const amazonPaymentUI = new AmazonPayUIFactory(
        $paymentButton,
        '/ajax_get_minimum_order_value',
        null,
        new Logger('AMAZON_PAY')
      ).getPlugin();

      // Register as product details plugin if available
      if (
        typeof ShopgateProductDetailsCore === 'object'
        && typeof ShopgateProductDetailsCore.registerPlugin === 'function'
      ) {
        ShopgateProductDetailsCore.registerPlugin(amazonPaymentUI);
      }

      return true;
    });
  };

  /**
   * Checkout buttons jquery plugin
   * @param {Object} opts opts
   * @return {jQuery}
   */
  $.fn.shopgateAmazonPaymentsCheckout = function (opts) {
    const defaults = {
      amazonPaymentsData: '',
      checkoutReloadUrl: '',
      targetSelector: '.cart',
    };

    const options = $.extend(true, {}, defaults, opts);

    if (options.amazonPaymentsData.isApp) {
      return $();
    }

    /**
     *
     */
    function reloadCheckout() {
      const checkoutButton = $('button.btn-cart');

      /**
       * Updates shipping widget.
       * @param {Object} data data
       */
      function updateShippingWidget(data) {
        const widget = $('.order-label.shipping');
        const serviceWrapper = widget.find('.shipping-service-wrapper');
        const serviceWrapperMain = serviceWrapper.find('.main-content');
        const serviceWrapperAmount = serviceWrapper.find('.amount-formatted');
        const serviceIcon = widget.find('.shipping-icon');
        const alertWrapper = widget.find('.alert');
        const editButton = widget.find('.btn');

        if (data.show_shipping) {
          widget.removeClass('hidden');
        } else {
          widget.addClass('hidden');
        }

        if (data.error) {
          serviceWrapper.addClass('hidden');
          serviceWrapperMain.html('');
          alertWrapper.removeClass('hidden').text(data.text);
          widget.addClass('has-error');
        } else {
          serviceWrapper.removeClass('hidden');
          serviceWrapperMain.html(data.text);
          alertWrapper.addClass('hidden').text('');
          widget.removeClass('has-error');
        }

        if (data.formatted_amount) {
          serviceWrapperAmount.html(data.formatted_amount).removeClass('hidden');
        } else {
          serviceWrapperAmount.html('').addClass('hidden');
        }

        if (data.show_edit_button) {
          editButton.removeClass('hidden');
        } else {
          editButton.addClass('hidden');
        }

        if (data.image_url) {
          serviceIcon.empty().append($('<img>').attr('src', data.image_url)).removeClass('hidden');
        } else {
          serviceIcon.empty().addClass('hidden');
        }
      }

      /**
       * Success callback
       * @param {Object} data data
       */
      function success(data) {
        if (data.data) {
          updateShippingWidget(data.data.checkout_data.shipping);
          $('button.btn-cart').removeClass('disabled locked');
        }
      }

      $.shopgate.ajaxContentUpdate({
        url: options.checkoutReloadUrl,
        targetSelector: options.targetSelector,
        data: {
          reload_cart: true,
        },
        success,
        beforeSend: () => {
          $('.order-label.shipping').animate({
            opacity: '.4',
          }).find('.btn').addClass('disabled');
          checkoutButton.prop('disabled', true);
        },
        complete: () => {
          $('.order-label.shipping').animate({
            opacity: '1',
          }).find('.btn').removeClass('disabled');
          checkoutButton.prop('disabled', false);
        },
      });
    }

    /**
     * Inits address book
     */
    function initAddressBook() {
      new OffAmazonPayments.Widgets.AddressBook({
        sellerId: options.amazonPaymentsData.merchant_id,
        amazonOrderReferenceId: options.amazonPaymentsData.session_id,
        design: {
          designMode: 'smartphoneCollapsible',
        },
        displayMode: options.amazonPaymentsData.displayMode ? options.amazonPaymentsData.displayMode : 'edit',
        // AmazonOrderReferenceId obtained from Button widget
        onAddressSelect: () => {
          $('button.btn-cart').addClass('disabled locked');
          reloadCheckout();
        },
        onError: () => {
          $('button.btn-cart').addClass('disabled locked');
        },
      }).bind('addressBookWidgetDiv');
    }

    /**
     * Inits wallet
     */
    function initWallet() {
      new OffAmazonPayments.Widgets.Wallet({
        sellerId: options.amazonPaymentsData.merchant_id,
        amazonOrderReferenceId: options.amazonPaymentsData.session_id,
        design: {
          designMode: 'smartphoneCollapsible',
        },
        onPaymentSelect: () => {},
        onError: () => {
          $('button.btn-cart').addClass('disabled locked');
        },
      }).bind('walletWidgetDiv');
    }

    return this.each(() => {
      const $paymentButton = $(this);

      if (typeof OffAmazonPayments === 'undefined') {
        $paymentButton.hide();
        console.log('OffAmazonPayments undefined');
        return false;
      }

      if (options.amazonPaymentsData.session_id && options.amazonPaymentsData.merchant_id) {
        initAddressBook();
        initWallet();
      }
      return true;
    });
  };
})(jQuery));



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-amazon-payments.js